// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"13834fab","732":"41c2c3de","977":"1f47a4e2"}[chunkId] + ".chunk.js";
};